(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!customElements.get('emki-options-shortcut')) {
    customElements.define('emki-options-shortcut', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.link = this.querySelector('a');
        this.sectionRoot = this.closest('.shopify-section');
        const refresh = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const picker = this.sectionRoot.querySelector('variant-picker');
            this.link.hidden = !picker || picker.getBoundingClientRect().top < window.innerHeight - 140 || window.innerWidth >= 750;
          });
        };
        this.link.addEventListener('click', event => {
          const picker = this.sectionRoot.querySelector('variant-picker');
          if (!picker) return;
          event.preventDefault();
          picker.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        }, {signal:this.controller.signal});
        window.addEventListener('scroll', refresh, {passive:true, signal:this.controller.signal});
        window.addEventListener('resize', refresh, {passive:true, signal:this.controller.signal});
        this.observer = new ResizeObserver(refresh);
        this.observer.observe(this.sectionRoot);
        refresh();
      }
      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
